// extracted by mini-css-extract-plugin
export default {"label":"kUcF29zTKmGy4r4SAuR9","labelRequired":"N5xuWEcBTFjpVqW4zC3z"};